import { MouseEvent, useCallback } from 'react';

import { BomLinkProps } from '@/components/generic/BomLink/types';

import styles from './BomLink.module.scss';

export const BomLink = ({ proposalId, fontSize }: BomLinkProps) => {
  const onClick = useCallback(
    (evt: MouseEvent) => {
      evt.preventDefault();
      if (!proposalId) return;

      window.open(`${window.location.origin}/${proposalId}/estimated-bom`, '_blank');
    },
    [proposalId],
  );

  return (
    <a className={styles.bom_link_button} onClick={onClick} role="link" style={{ fontSize }}>
      Estimated Solar Materials Cost
    </a>
  );
};
